import { render, staticRenderFns } from "./BigHeader.vue?vue&type=template&id=1f39ca7d&scoped=true&"
import script from "./BigHeader.vue?vue&type=script&lang=ts&"
export * from "./BigHeader.vue?vue&type=script&lang=ts&"
import style0 from "./BigHeader.vue?vue&type=style&index=0&id=1f39ca7d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f39ca7d",
  null
  
)

export default component.exports